<div class="section_wrapper">
    <div class="arrow"><h1>Help</h1> <a [routerLink]="['/']"><img src="assets/help/arrow.svg" alt=""></a></div>
    <br>
    <p>Welcome to the help page for <strong>Join</strong>, your guide to using our kanban project management tool. Here, we'll provide an
        overview of what <strong>Join</strong> is, how it can benefit you, and how to use it.</p>
        <br>
    <h3>What is Join?</h3>
    <br>
    <p><strong>Join</strong> is a kanban-based project management tool designed and built by a group of dedicated students as part of
        their web development bootcamp at the Developer Akademie.</p>
    <br>
    <p>Kanban, a Japanese term meaning "billboard", is a highly effective method to visualize work, limit
        work-in-progress, and maximize efficiency (or flow). <strong>Join</strong> leverages the principles of kanban to help users
        manage their tasks and projects in an intuitive, visual interface.</p>
    <br>
    <p>It is important to note that <strong>Join</strong> is designed as an educational exercise and is not intended for extensive
        business usage. While we strive to ensure the best possible user experience, we cannot guarantee consistent
        availability, reliability, accuracy, or other aspects of quality regarding <strong>Join</strong>.</p>
        <br>
    <h3>How to use it</h3>
    <br>
    <p>Here is a step-by-step guide on how to use <strong>Join</strong>:</p>
    <br>

    <div class="title">
        <p class="number">1.</p>
        <div>
            <h4> Exploring the Board</h4>
            <p>When you log in to <strong>Join</strong>, you'll find a default board. This board represents your project
                and contains four default lists: "To Do", "In Progress", "Await feedback", and "Done".</p>
        </div>
    </div>
<br>
    <div class="title">
        <p class="number">2.</p>
        <div>
            <h4> Creating Contacts</h4>
            <p>In <strong>Join</strong>, you can add contacts to collaborate on your projects. Go to the "Contacts"
                section, click on "New contact", and fill in the required information. Once added, these contacts can be
                assigned tasks and they can interact with the tasks on the board.</p>
        </div>
    </div>
    <br>

    <div class="title">
        <p class="number">3.</p>
        <div>
            <h4> Adding Cards</h4>
            <p>Now that you've added your contacts, you can start adding cards. Cards represent individual tasks.
                Click the "+"
                button under the appropriate list to create a new card. Fill in the task details in the card, like
                task name,
                description, due date, assignees, etc.</p>
        </div>
    </div>
    <br>
    <div class="title">
        <p class="number">4.</p>
        <div>
            <h4> Moving Cards</h4>
            <p>As the task moves from one stage to another, you can reflect that on the board by dragging and dropping
                the
                card
                from one list to another.</p>
        </div>
    </div>
    <br>
    <div class="title">
        <p class="number">5.</p>
        <div>
            <h4> Deleting Cards</h4>
            <p>Once a task is completed, you can either move it to the "Done" list or delete it. Deleting a card will
                permanently remove it from the board. Please exercise caution when deleting cards, as this action is
                irreversible.</p>
            <br>
            <p>Remember that using <strong>Join</strong> effectively requires consistent updates from you and your team
                to
                ensure the board reflects the current state of your project.</p>
            <br>
            <p>Have more questions about <strong>Join</strong>? Feel free to contact us at <a>[Your Contact Email]</a>.
                We're
                here to help you!</p>
        </div>
    </div>
</div>


